import client from './httpClient';

export const sendEvent = (streamName, data) =>
  client.put(`streams/${streamName}/record`, { data: { ...data, timestamp: Date.now() } });

export const sendEventBatch = (streamName, data = []) => client.put(`streams/${streamName}/record-batch`, data);
